import {
  Button,
  Modal,
  Form,
  Radio,
  Col,
  Select,
  Row,
  Tabs,
  Space,
} from "antd";
import {
  getClientAPI,
  GetPartnersApi,
  GetPartnerSubClientsApi,
} from "CommonComponents/Lookup/LookupAPI";
import {
  resetClients,
  resetPartnerSubClients,
  resetPartners,
} from "CommonComponents/Lookup/LookupSlice";
import {
  resetClientDetailsById,
  resetEstimateById,
  resetPartnerClientDetailsById,
} from "features/Clients/ClientsSlice";
import { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ScheduleLeave from "./ScheduleLeave";
import { GetWorkOrdersListByClientId } from "features/Clients/ClientsApi";
import DispatchTool from "features/Clients/Appointments/DispatchTool";

function SelectClient(props) {
  const intl = useIntl();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const companyId = localStorage.getItem("CompanyId");
  const clients = useSelector((state) => state.lookup.clientList);
  const partners = useSelector((state) => state.lookup.partnersList);
  const partnerSubClients = useSelector(
    (state) => state.lookup.partnerSubClients
  );
  const workOrdersFromRedux = useSelector(
    (state) => state.clients.workOrdersList
  );
  const [isPartner, setIsPartner] = useState(false);
  const [partnerSearchTerm, setPartnerSearchTerm] = useState("");
  const [clientSearchTerm, setClientSearchTerm] = useState("");
  const [selectedClientId, setSelectedClientId] = useState(null);
  const [selectedWorkOrderId, setSelectedWorkOrderId] = useState(null);
  const [selectedPartnerId, setSelectedPartnerId] = useState(null);
  const [activeTabKey, setActiveTabKey] = useState("1");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleSubmit = async () => {
    try {
      await form.validateFields();
      setIsModalOpen(true);
    } catch (errorInfo) {
      console.log("Validation Failed:", errorInfo);
    }
  };

  const handleCancel = () => setIsModalOpen(false);

  const modalTitle = <FormattedMessage id="Appointment.BookAppointment" />;

  const submitButtonText = (
    <FormattedMessage id="Appointment.BookAppointment" />
  );
  const handleSwitch = () => {
    form.setFieldsValue({ clientId: null, partnerId: null });
    setSelectedClientId(null);
    setSelectedPartnerId(null);
    dispatch(resetPartners());
    dispatch(resetClients());
    dispatch(resetPartnerSubClients());
  };

  useEffect(() => {
    if (clientSearchTerm != "") {
      if (selectedPartnerId) {
        dispatch(GetPartnerSubClientsApi(selectedPartnerId, clientSearchTerm));
      } else {
        dispatch(getClientAPI(clientSearchTerm));
      }
    }
    dispatch(resetClients());
    dispatch(resetPartnerSubClients());
  }, [clientSearchTerm]);

  useEffect(() => {
    if (partnerSearchTerm != "") {
      dispatch(GetPartnersApi(partnerSearchTerm));
    }
    dispatch(resetPartners());
    if (selectedClientId) {
      const pagination = { pageNo: 1, pageSize: 10, searchQuery: "" };
      dispatch(GetWorkOrdersListByClientId(pagination, selectedClientId));
    }
  }, [partnerSearchTerm, selectedClientId]);

  useEffect(() => {
    dispatch(resetClientDetailsById());
    dispatch(resetPartnerClientDetailsById());
    dispatch(resetEstimateById());
  }, []);

  return (
    <>
      <Modal
        title={modalTitle}
        closable={{ "aria-label": "Custom Close Button" }}
        open={props.open}
        width={900}
        onCancel={props.onCancel}
        //   footer={[
        //     <Button key="cancel" onClick={() => props.onCancel()}>
        //       <FormattedMessage id="Common.Cancel" />
        //     </Button>,
        //     <Button key="send" type="primary" onClick={() => handleSubmit()}>
        //       {submitButtonText}
        //     </Button>,
        //   ]}
        footer={null}
      >
        <p>
          {activeTabKey === "1" ? (
            <FormattedMessage id="AddAppointment.QuickReschedule" />
          ) : (
            <FormattedMessage id="AddAppointment.QuicklyBlock" />
          )}
        </p>
        <Tabs
          activeKey={activeTabKey}
          onChange={setActiveTabKey}
          className="mt-20"
        >
          <Tabs.TabPane
            tab={<FormattedMessage id="Dispatch.Appointment" />}
            key="1"
          >
            <Form form={form} name="basic" layout="vertical">
              <Form.Item label={<FormattedMessage id="ProductService.Type" />}>
                <Radio.Group
                  onChange={(e) => {
                    setIsPartner(e.target.value === "partner");
                    handleSwitch();
                  }}
                  defaultValue="client"
                >
                  <Radio value="client">
                    <FormattedMessage id="AddProject.Client" />
                  </Radio>
                  <Radio value="partner">
                    <FormattedMessage id="Dashboard.Clients.Partner" />
                  </Radio>
                </Radio.Group>
              </Form.Item>
              <Row gutter={16}>
                {isPartner && (
                  <Col xs={24} sm={24}>
                    <Form.Item
                      label={
                        <FormattedMessage id="Dashboard.Clients.PartnerName" />
                      }
                      name="partnerId"
                      rules={[
                        {
                          required: true,
                          message: intl.formatMessage({
                            id: "AddEstimate.error.PleaseSelectpartner",
                          }),
                        },
                      ]}
                    >
                      <Select
                        size="large"
                        showSearch
                        allowClear
                        filterOption={false}
                        placeholder={intl.formatMessage({
                          id: "Dashboard.Quotes.Placeholder.SelectPartner",
                        })}
                        onSearch={(value) => setPartnerSearchTerm(value)}
                        onChange={(value) => {
                          setSelectedPartnerId(value || null);
                          if (!value) {
                            dispatch(resetPartners());
                            form.setFieldsValue({ clientId: null });
                            setSelectedClientId(null);
                          }
                        }}
                        optionLabelProp="label"
                        notFoundContent={null}
                      >
                        {(partners || [])
                          .filter((cl) => cl.isActive)
                          .map((cl) => (
                            <Select.Option
                              key={cl.id}
                              value={cl.id}
                              label={cl.companyName}
                            >
                              {cl.companyName} | {cl.phone}
                            </Select.Option>
                          ))}
                      </Select>
                    </Form.Item>
                  </Col>
                )}
                <Col xs={24} sm={24}>
                  <Form.Item
                    label={<FormattedMessage id="AddEstimate.ClientName" />}
                    name="clientId"
                    rules={[
                      {
                        required: true,
                        message: intl.formatMessage({
                          id: "AddEstimate.error.PleaseSelectClient",
                        }),
                      },
                    ]}
                  >
                    <Select
                      size="large"
                      placeholder={intl.formatMessage({
                        id: "AddEstimate.Placeholder.SelectClient",
                      })}
                      showSearch
                      allowClear
                      disabled={isPartner && !selectedPartnerId}
                      filterOption={false}
                      onSearch={(value) => setClientSearchTerm(value)}
                      onChange={(value) => {
                        setSelectedClientId(value || null);
                        if (!value) {
                          if (isPartner) {
                            dispatch(resetPartnerSubClients());
                          } else {
                            dispatch(resetClients());
                          }
                        }
                      }}
                      optionLabelProp="label"
                      notFoundContent={null}
                    >
                      {((isPartner ? partnerSubClients : clients) || [])
                        .filter((cl) => cl.isActive)
                        .map((cl) => (
                          <Select.Option
                            key={cl.id}
                            value={cl.id}
                            label={
                              cl.isResidential ? cl.nameEn : cl.companyName
                            }
                          >
                            {cl.isResidential ? cl.nameEn : cl.companyName} |{" "}
                            {cl.phone}
                          </Select.Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24}>
                  <Form.Item
                    label="Work Order"
                    name="workOrderId"
                    rules={[
                      {
                        required: true,
                        message: intl.formatMessage({
                          id: "AddEstimate.error.PleaseSelectWorkOrder",
                        }),
                      },
                    ]}
                  >
                    <Select
                      size="large"
                      placeholder="Select work order"
                      disabled={!selectedClientId}
                      allowClear
                      showSearch
                      optionFilterProp="children"
                      onChange={(value) =>
                        setSelectedWorkOrderId(value || null)
                      }
                    >
                      {(workOrdersFromRedux || []).map((wo) => (
                        <Select.Option key={wo.id} value={wo.id}>
                          {wo.woNumber}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row className="text-center">
                <Col span={24}>
                  <Space>
                    <Button key="cancel" onClick={() => props.onCancel()}>
                      <FormattedMessage id="Common.Cancel" />
                    </Button>

                    <Button
                      key="send"
                      type="primary"
                      onClick={() => handleSubmit()}
                    >
                      {submitButtonText}
                    </Button>
                  </Space>
                </Col>
              </Row>
            </Form>
          </Tabs.TabPane>
          <Tabs.TabPane
            tab={<FormattedMessage id="Dispatch.ScheduleLeave" />}
            key="2"
          >
            <ScheduleLeave initialValues={props} />
          </Tabs.TabPane>
        </Tabs>
      </Modal>
      <Modal
        title={<FormattedMessage id="Appointment.BookAppointment" />}
        open={isModalOpen}
        onCancel={handleCancel}
        width={900}
        footer={null}
        centered
      >
        <DispatchTool
          onClose={handleCancel}
          initialValues={props}
          workOrderId={selectedWorkOrderId}
          selectedClientId={selectedClientId}
          selectedPartnerId={selectedPartnerId}
        />
      </Modal>
    </>
  );
}
export default SelectClient;
